import React from 'react';

export default function Hamster() {
  return (
    <div className="quote">
      <h2 className="hamster-header">Taking Care of Garlock</h2>
      <ol className="hamster">
        <li>
          Take the blanket &amp; stuffed animal off the top of the cage. Set
          aside.
        </li>

        <li>
          Put some of the used bedding in the green carrying case &amp; dump out
          the remaining food into it as well.
        </li>

        <li>
          Take Garlock out of the cage using the carrying case & carefully close
          the lid and put him in an adjacent room that doesn&apos;t have the
          lights on ( All you should have to do is open the front door of the
          cage & hold the carrying case up to it at an angle and he should just
          walk right in. If he&apos;s too hesitant you can bait him with a
          little piece of lettuce or a small carrot or something. Try to avoid
          grabbing or picking him up).
        </li>

        <li>
          Take the water bottle out of its holder on the side of the cage , then
          dump it out and refill with fresh tap water. Place aside.
        </li>

        <li>
          Take out the little house on the top floor & then use a paper towel to
          push the bedding/whatever else that&apos;s on the 2nd &amp; top floors
          into the ground floor
        </li>

        <li>Take out all 3 wooden ladders &amp; set aside</li>

        <li>
          Unclip all 4 sides of the cage and lift off , then set aside on the
          floor somewhere else in the room (on the wood floor not the rugs
          please). Leave the wheel where it is.
        </li>
        <li>
          Remove the little house, wooden bridge , & random stuff laying about &
          set aside. (pinecones, chew blocks, etc.) Take the mug out and set
          aside too.
        </li>
        <li>
          Take a large trash bag and open it up. Then begin scooping out all the
          bedding on the bottom of the cage into the trash bag. Once all of
          it&apos;s in there,make sure there isn&apos;t any little poop pieces
          left. If there&apos;s a tiny bit of bedding it&apos;s no big deal.
        </li>
        <li>
          Fill up the empty cage with the regular bedding until it&apos;s ~70%
          full. Then take the &quot;grass-like&quot; bedding and also drop a
          handful of that atop it and mix it all around. You&apos;ll have to
          break up the regular bedding with your hands a bit so it&apos;s not in
          chunks , otherwise the animal can&apos;t properly make his burrows and
          it won&apos;t evenly distribute along the bottom of the container.
          Doesn&apos;t have to be perfect but do the best you can.
        </li>
        <li>
          Now you put everything back as it was. Try to place things in the same
          spots as they were before.
        </li>
        <li>
          Put the water bottle in it&apos;s clip as it was as well, but not too
          high up so he is able to reach it easily.
        </li>
        <li>
          Fill up one of the food bowls with his Hamster Müsli that&apos;s on
          the little shelf below the cage. Easy to find.
        </li>
        <li>
          Place the wooden ladders back where they were as well. If you
          don&apos;t recall exactly where they were you can reference the
          photos.
        </li>
        <li>
          Put the mug back right underneath the 2nd floor. It should slightly
          support the wooden floor above it.
        </li>
        <li>
          If what you&apos;re seeing looks like the reference photos then good
          job you&apos;re almost done!
        </li>
        <li>
          Go grab garlock in his carrying case and gently open the top and angle
          it so he can enter the opened front door of the cage. He should be
          pretty eager to get back inside.
        </li>
        <li>
          Dump the remaining bedding that was placed in the carrying case in the
          same trash bag that you dumped the rest of the dirty bedding.
        </li>
        <li>
          Close the cage & place the yellow blanket back atop the cage once
          more.
        </li>
        <li>
          Take 10 individual (fresh) toilet paper tissues and strew them about
          inside the cage. Doesn&apos;t really matter where, it&apos;s just
          important that they&apos;re in individual squares.
        </li>
        <li>Close the cage, both on top and in front. </li>
        <li>
          Done! Good job. Reference the photos in case you&apos;re uncertain.
        </li>
        <li>
          Throw away the trash bag with the dirty bedding it in the dumpster
          outside.
        </li>
      </ol>
    </div>
  );
}
